export default {
  general: [
    {
      q: "What is a hackathon?",
      a: "A hackathon is a type of technical competition! We provide our attendees with the opportunity to work with new people on cool ideas, and the resources necessary to make those ideas come to life. We do not condone, nor do we allow any actual hacking or other illegal activities! DeltaHacks is an official MLH event. The MLH code of conduct can be found here: http://mlh.io/code-of-conduct",
    },
    {
      q: "What is DeltaHacks?",
      a: `The word “delta Δ” stands for change, and we used this definition to name DeltaHacks - McMaster’s annual Hackathon for Change. This year, DeltaHacks will be a 500-particiapnt event taking place the first week of Jan 2022. We hope to inspire students to hack for positive changes that align with their passions - whether it's for the environment, health, inequality, education, or more!`,
    },
    {
      q: "Who can participate?",
      a: `Anyone who is willing to learn and have fun! If you have an idea - or even if you don't, you're invited! All university and high school students over 13 during the date of the event are welcome at DeltaHacks!`,
    },
    {
      q: "I have never been to a hackathon before, what should I do?",
      a: "We love first time hackers! We will be providing mentors during the hackathon and running workshops, so you’re welcome no matter your skill or experience level.",
    },
    {
      q: "How much does it cost?",
      a: "Absolutely nothing! All you need is a personal computer and internet connection as DeltaHacks will be online this year.",
    },
  ],
  logistics: [
    {
      q: "Will DeltaHacks 8 be in person or virtual?",
      a: "Attendee safety is our top priority, so DeltaHacks will be taking place online this year. We are currently considering different options for online platforms. Further details will be released closer to the event date!",
    },
    {
      q: "Will attendees still get awesome swag?",
      a: `Our team is working hard to get swag items ready to go and be sent out to attendees safely. So yes, there will be awesome swag for participants, mentors, and sponsors.`,
    },
    {
      q: `What's the event schedule like?`,
      a: `We'll be putting up one closer to the event, you can expect a lot of talks and presentations, fun events, and a lot of chances to meet new people and win prizes!`,
    },
    {
      q: "What do I need to participate?",
      a: "As DeltaHacks 8 will be online, all you require is a computer and an internet connection! Also grab some yummy snacks and be ready to build some amazing projects!",
    },
    {
      q: "Will hardware be provided?",
      a: `Unfortunately, due to current circumstances, hardware cannot be provided to hackers this year. But you are encouraged to use hardware in your hacks if you have the materials available!`,
    },
  ],
  application: [
    {
      q: `What's the application deadline?`,
      a: `Priority applications are due Sunday, October 31, 2021. Apply by then for a better chance to be accepted!`,
    },
    {
      q: "How long will it be until I hear back about my application?",
      a: `Our team is working long and hard to mark incoming applications. All decisions are sent out at the same time to your personal emails, about a month after the deadline.`,
    },
  ],
  misc: [
    {
      q: "How big can a team be?",
      a: "Your team can be anywhere up to four people including you, that means you can hack totally alone or in a group of three others, the choice is yours.",
    },
    {
      q: "Do I have to have a team going into the event?",
      a: "Nope! If you do, great! If not, there will be opportunities to network before and during the event to find some other hackers to build a project with.",
    },
    {
      q: "What am I allowed to hack?",
      a: "Your hack can be absolutely anything! There will be certain challenges your team can work towards, and you can win amazing prizes (to be released later) if your submission wins the category!",
    },
    {
      q: "How are projects judged?",
      a: "Projects are judged by event sponsors and experts from the tech sector. Projects are presented to judges at the exposition and evaluated on multiple factors such as presentation, creativity, practical application, and originality.",
    },
  ],
};
